import { Box, Button, Card, Typography } from "@mui/material";
import { useNavigate } from "react-router";

export const PostAccountSyncView = ({
  infoConfirmed,
  syncingData,
  dataSynced,
}: {
  infoConfirmed: boolean;
  syncingData: boolean;
  dataSynced: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Box
        sx={{
          p: 3,
          display: infoConfirmed && syncingData ? "flex" : "none",
          backgroundColor: "#FFF",
          borderRadius: "10px",
          minHeight: "300px",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Typography>We are getting your account ready.</Typography>
      </Box>
      <Box
        sx={{
          p: 3,
          borderRadius: "10px",
          minHeight: "300px",
          display: infoConfirmed && dataSynced ? "flex" : "none",
          flexDirection: "column",
          gap: 4,
        }}
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            padding: 2,
          }}
        >
          <Box
            sx={{
              dispaly: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography variant="h5">
              Find Health Insurance With Jamie
            </Typography>
            <Typography>Jamie is your AI Health Insurance Advocate</Typography>
          </Box>
          <Button
            variant="outlined"
            onClick={() => {
              navigate("/exit/jamie");
            }}
          >
            Start
          </Button>
        </Card>
        <Card
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            padding: 2,
          }}
        >
          <Box
            sx={{
              dispaly: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography variant="h5">Go To Your Dashboard</Typography>
            <Typography>Lets help you with what you need</Typography>
          </Box>
          <Button
            variant="outlined"
            onClick={() => {
              navigate("/account/dashboard");
            }}
          >
            Start
          </Button>
        </Card>
      </Box>
    </>
  );
};
